//https://github.com/vuejs/vuex/tree/dev/examples/shopping-cart/store
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js